import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [consultant, setConsultant] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("gs_token");
    if (!token) {
      setUser(null);
      setConsultant(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setConsultant(data.consultant || null);
    } catch {
      localStorage.removeItem("gs_token");
      setUser(null);
      setConsultant(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("gs_token", data.token);
    setUser(data.user);
    setConsultant(data.consultant || null);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("gs_token");
    setUser(null);
    setConsultant(null);
  };

  return (
    <AuthCtx.Provider value={{ user, consultant, loading, login, logout, refresh, setConsultant }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
